import { createContext } from "react"

export const TaskListContext = createContext();